/**
 * Cross-shell work queue sync: AgenticRCM Work Queue actions broadcast so
 * Denial / Claims / other RCM dashboards can refresh aggregated stats.
 */
export const RCM_WORKQUEUE_SYNC_CHANNEL = 'rcm-workqueue-sync';

export function broadcastWorkQueueChanged(detail = {}) {
  try {
    if (typeof BroadcastChannel !== 'undefined') {
      const ch = new BroadcastChannel(RCM_WORKQUEUE_SYNC_CHANNEL);
      ch.postMessage({ type: 'changed', ts: Date.now(), ...detail });
      ch.close();
    }
  } catch (_) {
    /* ignore */
  }
  try {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('rcm-workqueue-sync', { detail: { type: 'changed', ...detail } })
      );
    }
  } catch (_) {
    /* ignore */
  }
}

/** Returns unsubscribe. Safe to call from React useEffect cleanup. */
export function subscribeWorkQueueSync(callback) {
  let bc;
  try {
    if (typeof BroadcastChannel !== 'undefined') {
      bc = new BroadcastChannel(RCM_WORKQUEUE_SYNC_CHANNEL);
      bc.onmessage = (ev) => {
        if (typeof callback === 'function') callback(ev.data || {});
      };
    }
  } catch (_) {
    /* ignore */
  }
  const onWin = (ev) => {
    if (typeof callback === 'function') callback(ev.detail || {});
  };
  if (typeof window !== 'undefined') {
    window.addEventListener('rcm-workqueue-sync', onWin);
  }
  return () => {
    try {
      bc?.close();
    } catch (_) {
      /* ignore */
    }
    if (typeof window !== 'undefined') {
      window.removeEventListener('rcm-workqueue-sync', onWin);
    }
  };
}
